import PropTypes from 'prop-types';
import { FormattedName } from 'components/Formatters';
import BookingDetails from './BookingDetails';
import HotelDetails from './HotelDetails';
import HelpInfo from './HelpsInfo';
import BookingConfirmation from './BookingConfirmation';
import KnowBeforeYouGo from './KnowBeforeYouGo';
import QFFPoints from './QFFPoints';
import PaymentSummary from './PaymentSummary';
import { PrintViewHorizontalRule } from './primitives';
import { Container, SectionContainer, Spacer } from '../primitives';

const inclusionsToText = (inclusions) => inclusions.reduce((incs, inc) => `${incs ? `${incs}, ` : ''}${inc.name}`, '');

const Body = ({ booking }) => (
  <SectionContainer>
    <Container>
      <BookingConfirmation reservationSummaryText={booking.summaryText} />
      <Spacer />
      <BookingDetails
        leadGuestName={FormattedName({ name: booking.reservation.leadGuest.name })}
        totalAdults={booking.reservation.adults}
        totalChildren={booking.reservation.children}
        totalInfants={booking.reservation.infants}
        checkIn={booking.reservation.formattedCheckIn}
        checkInAfter={booking.reservation.property.checkInAfter}
        checkOut={booking.reservation.formattedCheckOut}
        checkOutBefore={booking.reservation.property.checkOutBefore}
      />
      <Spacer />
      <HotelDetails
        hotelName={booking.reservation.property.name}
        hotelAddress={booking.reservation.property.formattedAddress}
        hotelPhone={booking.reservation.property.phone}
        hotelEmail={booking.reservation.property.email}
        roomType={booking.reservation.roomType.name}
        bedGroupDescription={booking.reservation.bedGroupDescription}
        offerDescription={booking.reservation.offer.name}
        inclusions={inclusionsToText(booking.reservation.offer.inclusions)}
        specialRequests={booking.reservation.specialRequests}
      />
      <Spacer />
      <PaymentSummary breakdown={booking.paidBeforeCancellation.breakdown} />
      <Spacer />
      <QFFPoints
        memberNumber={booking.reservation.qffEarnNumber}
        earnedPoints={booking.reservation.totalQffPointsEarned}
        awardedPoints={booking.reservation.totalQffPointsAwarded}
      />
      <PrintViewHorizontalRule />
      <HelpInfo bookingRef={booking.reference} />
      <PrintViewHorizontalRule />
      <KnowBeforeYouGo
        checkInInstructions={booking.reservation.property.checkInInstructions}
        hotelPolicies={booking.reservation.property.roomInformation}
        cancellationPolicy={booking.reservation.cancellationPolicy.description}
      />
      <PrintViewHorizontalRule />
    </Container>
  </SectionContainer>
);

Body.propTypes = {
  booking: PropTypes.shape({}),
};

export default Body;
